import { Routes } from '@angular/router';
import { mainRoutes } from './core/routes/main-routes';
import { authRoutes } from './core/routes/auth-routes';
import { LayoutComponent } from './layout/main-layout/layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { AppRoutes } from './core/models/routes.model';
import { ConfirmEmailComponent } from './layout/auth-layout/confirm-email/confirm-email.component';
import { ResetPasswordComponent } from './layout/auth-layout/reset-password/reset-password.component';

export const appRoutes: Routes = [
  { path: AppRoutes.AUTH, component: AuthLayoutComponent, children: authRoutes },
  // Verifica email: il link di Odoo punta a `/confirm-email?token=...`, quindi la
  // rotta deve stare al primo livello e restare senza guard.
  {
    path: AppRoutes.CONFIRM_EMAIL,
    component: AuthLayoutComponent,
    children: [{ path: '', component: ConfirmEmailComponent }],
  },
  // Reset password: il link dell'email punta a `/reset-password?token=...`.
  {
    path: AppRoutes.RESET_PASSWORD,
    component: AuthLayoutComponent,
    children: [{ path: '', component: ResetPasswordComponent }],
  },
  {
    path: AppRoutes.NOT_FOUND,
    loadChildren: () =>
      import('./features/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
  // Il ramo applicativo è pubblico: vetrina, carrello e checkout devono essere
  // navigabili da chiunque. Le sole rotte riservate (acquisti, profilo,
  // aziende, procuratori) dichiarano il proprio authGuard in `mainRoutes`.
  {
    path: AppRoutes.MAIN_ROUTE,
    component: LayoutComponent,
    children: mainRoutes,
  },
  { path: '', redirectTo: AppRoutes.MAIN_ROUTE, pathMatch: 'full' },
  { path: '**', redirectTo: AppRoutes.NOT_FOUND },
];
